import { Breadcrumbs } from "../../components";
import { getFullPath, routes } from "../../routes";
import { Link } from "react-router-dom";
import { String } from "@/util";
import { TestEvent } from "@/api/williams/testEvents";

export function TestResultsBreadcrumbs({ testEvent }: { testEvent: TestEvent }) {
  return (
    <>
      {testEvent?.project && (
        <Breadcrumbs>
          <Link className="link-primary" to={getFullPath(routes.project.list)}>
            Projects
          </Link>
          <Link className="link-primary" to={getFullPath(routes.project.open(testEvent.project.id))}>
            {String.truncate(testEvent.project.number, 15)}
          </Link>
          <Link className="link-primary" to={getFullPath(routes.testEvent.list)}>
            Events
          </Link>
          <Link className="link-primary" to={getFullPath(routes.testEvent.open(testEvent.id))} state={testEvent}>
            {testEvent.number}
          </Link>
          <Link className="link-primary" to={window.location.href} state={{ skipSavePrompt: true }}>
            Results
          </Link>
        </Breadcrumbs>
      )}
    </>
  );
}
